export const ALL_API_CONSTANTS = {
    review: {
        allDocuments: '/api/alldocuments/',
        suggestedDocuments: '/api/suggested/document/',
        addDocuments: "/api/document/",
        allFolders: "/api/cu-subproject/",
        allBatches: "/api/batch-create",
    }
}
